import { NgModule } from '@angular/core';
import { ServiceWorkerModule as AngularServiceWorkerModule } from '@angular/service-worker';
import { environment } from '@y42/environment';
import { ServiceWorkerService } from './service-worker.service';

@NgModule({
  imports: [
    AngularServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production_build,
    }),
  ],
})
export class Y42ServiceWorkerModule {
  constructor(readonly serviceWorker: ServiceWorkerService) {}
}
